import React from "react";

import * as SC from "./CampaignName.styled";
import Section from "../Section/Section";

import MetricsArrowLeft from "../../../../../../images/dataViz/metricsArrowLeft.svg";

const CampaignName = ({
  isPrint,
  campaignName,
  orgaName,
  //Router
  history
}) => {
  return (
    <>
      <SC.Icon onClick={() => history.goBack()}>{!isPrint && <MetricsArrowLeft />}</SC.Icon>
      <Section title={campaignName} isCampaignName>
        <SC.OrgaName>{orgaName}</SC.OrgaName>
      </Section>
    </>
  );
};

export default CampaignName;
